<template>
  <v-app v-if="userLoaded && user">
    <v-toolbar app dense flat dark color="primary">
      <v-spacer></v-spacer>
      <v-toolbar-title class="playables-header-container">
        <span class="cursor-pointer" @click="handleGoPlayables">Mini Games</span>
        <v-btn outline depressed @click="handleExit">
          Выход
          <v-icon class="ml-2" small right>directions_run</v-icon>
        </v-btn>
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-content>
      <router-view></router-view>
    </v-content>
    <v-snackbar v-model="hasError" color="error">
      {{ errorText }}
      <v-btn flat dark @click="hasError = false">Close</v-btn>
    </v-snackbar>
  </v-app>
  <v-app v-else-if="userLoaded && !user">
    <v-content>
      <v-layout row justify-center align-center class="full-height">
        <v-card class="pt-4 pr-4 pl-4 pb-4">
          <h3 class="pb-3">Вы не авторизованы</h3>
          <v-btn color="primary" @click="routeLogin">Авторизоваться</v-btn>
        </v-card>
      </v-layout>
    </v-content>
  </v-app>
  <v-app v-else>
    <v-content>
      <v-layout row justify-center align-center class="full-height">
        <v-progress-circular :indeterminate="true"></v-progress-circular>
      </v-layout>
    </v-content>
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'App',
  data () {
    return {
      hasError: false,
      errorText: '',
      makeDark: false
    }
  },
  computed: {
    ...mapGetters(['user', 'userLoaded'])
  },
  mounted () {
    this.$eventHub.$on('error-request-notify', error => {
      const data = error.response.data || {}
      this.hasError = true
      this.errorText = data.detail || data.message || 'Неизвестная ошибка, обратитесь в поддержку'
    })
    this.fetchUser().catch((error) => {})
  },
  methods: {
    ...mapActions(['fetchUser']),
    handleGoPlayables () {
      this.$router.push({ name: 'Playables' })
    },
    routeLogin () {
      window.location.href = '/login'
    },
    handleExit () {
      window.location.href = '/logout'
    }
  },
  destroyed () {
    this.$eventHub.$off('error-request-notify')
  }
}
</script>

<style>
  .cursor-pointer { cursor: pointer; }
  .full-height { height: 100%; }
</style>
